// Servicio para el reporte "Control diario de producción" (Reporte 360 v2).
// Trae los registros crudos del mes de las 4 fuentes que alimentan la hoja del Excel:
// ciclos de lavado, recepciones (lotes), alistamientos y horas trabajadas.

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

const postFilter = async (path, body, errorMsg) => {
  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(`${errorMsg} (HTTP ${response.status}): ${text || response.statusText}`);
  }
  const json = await response.json();
  return Array.isArray(json?.data) ? json.data : [];
};

export const fetchControlDiario = async ({ idLavanderia, dateRange }) => {
  const [cycles, receptions, alistamientos, hours] = await Promise.all([
    postFilter('/washing-cycles/filter', {
      limit: 10000, page: 1, query: { 'lavanderia.id': idLavanderia, fecha: dateRange },
    }, 'Error al obtener los ciclos de lavado'),
    postFilter('/reception/filter', {
      limit: 10000, page: 1, query: { idLavanderia, createdAt: dateRange },
    }, 'Error al obtener las recepciones'),
    postFilter('/alistamientos/filter', {
      limit: 10000, page: 1, query: { lavanderiaId: idLavanderia, fechaCreacion: dateRange, estado: { $ne: 'Eliminado' } },
    }, 'Error al obtener los alistamientos'),
    postFilter('/worked-hours/filter', {
      limit: 10000, page: 1, query: { 'lavanderia.id': idLavanderia, fecha: dateRange },
    }, 'Error al obtener las horas trabajadas'),
  ]);
  return { cycles, receptions, alistamientos, hours };
};
